import styled from "styled-components";
import theme from "../../theme";

export const Container = styled.div`
  @media screen and (max-width: 568px) {
    .heading {
      flex-direction: column;
      gap: 20px;
      h3 {
        font-size: 15px;
        color: #2b2f38;
      }
    }
  }
  .link-buttons {
    display: flex;
    gap: 10px;
    .see-more,
    .add-campaign {
      padding: 10px 16px;
      height: 40px;
      border: 1px solid #989FAD;
      border-radius: 8px;
      font-size: 14px;
      background-color: transparent;
      text-decoration: none;
      cursor: pointer;
      color: #344054;
    }
    .see-more2 {
      padding: 10px 0px 10px 10px;
      height: 40px;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      font-size: 14px;
      background-color: transparent;
      text-decoration: none;
      cursor: pointer;
      color: #344054;
    }
    .add-campaign {
      color: #fff;
      border: 1px solid ${theme.color.brandDark};
      background-color: ${theme.color.brandDark};
    }
    .export-button {
    padding: 8px 16px;
    height: 40px;
    background-color: ${theme.color.brandDark};
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    margin-left: 10px;
    
    &:disabled {
      opacity: 0.7;
      cursor: not-allowed;
    }
  }
  }
  .heading {
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    h1 {
      font-size: 30px;
      line-height: 52px;
      color: #171a2f;
    }
    p {
      font-size: 16px;
      line-height: 24px;
      color: #546881;
    }
  }
  h3 {
    font-size: 20px;
    line-height: 30px;
    color: #2b2f38;
  }
`;
export const CardWrapper = styled.div`
  width: 100%;
  display: grid;
  gap: 20px;
  margin-bottom: 30px;
  //margin: auto;
  grid-template-columns: repeat(3, 1fr);

  @media (max-width: 976px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;
export const ChartWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  gap: 22px;

  @media (max-width: 1096px) {
    flex-direction: column;
  }

  .left {
    width: 74%;

    @media (max-width: 1096px) {
      width: 100%;
    }
  }
  .right {
    width: 36%;

    @media (max-width: 1096px) {
      width: 100%;
      display: flex;
      flex-direction: row;
      gap: 20px;
    }
    @media (max-width: 996px) {
      flex-direction: column;
    }
    @media (max-width: 826px) {
      flex-direction: row;
    }
    @media (max-width: 726px) {
      flex-direction: column;
    }
  }
`;
export const TableWrapper = styled.div`
  @media screen and (max-width: 568px) {
    .header {
      flex-direction: column;
      gap: 20px;
      h3 {
        font-size: 15px;
        color: #2b2f38;
      }
    }
  }
  .header {
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    margin-top: 40px;
    h3 {
      font-size: 20px;
      color: #2b2f38;
    }
    p {
      margin-top: 5px;
      font-size: 14px;
      color: #989fad;
    }
  }
`;
